export default __webpack_public_path__ + "static/media/assets-ads_00.0a7d80a6.jpg";